// removed by extract-text-webpack-plugin
module.exports = {"component":"_3LviMoNaBM_NfAVYTQBrP7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyInputField/GoeasyDisplayField/GoeasyDisplayField.scss
 ** module id = 973
 ** module chunks = 0
 **/